// Service-worker registration with an update hook. We register manually (rather
// than auto-injecting) so the UI can show "new version available" / "ready to
// work offline" prompts.

import { registerSW } from 'virtual:pwa-register';

export interface PwaState {
  offlineReady: boolean;
  needRefresh: boolean;
}

export function setupPwa(onChange: (state: PwaState) => void): () => void {
  const state: PwaState = { offlineReady: false, needRefresh: false };

  const updateSW = registerSW({
    immediate: true,
    onOfflineReady() {
      state.offlineReady = true;
      onChange({ ...state });
    },
    onNeedRefresh() {
      state.needRefresh = true;
      onChange({ ...state });
    },
  });

  // Returns a function the UI can call to apply the waiting update.
  return () => {
    void updateSW(true);
  };
}
